export function scrollTo(x, y) {
    if (window.scrollTo) {
        window.scrollTo(x, y);
    }
}



// WEBPACK FOOTER //
// ./common/window_helper.js